import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userBaseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_CLOUDLAB_AUTH_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
        // Get the JWT from Redux state
        const token = getState().user.jwt;
        
        // If we have a token, add it to the headers
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        
        // Add default headers
        headers.set('Content-Type', 'application/json');
        headers.set('Accept', '*/*');
        
        return headers;
    },
}); 